import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './AppRoot';

import './styles/reset.css';

/* global document */

  ReactDOM.render(<App />, document.getElementById('app'))



// WEBPACK FOOTER //
// src/app.jsx